import React from "react";
import ReactDOM from "react-dom/client";
import "./instrument";
import "./index.css";
import "@liquid/css/liquid.global.css";
import reportWebVitals from "./reportWebVitals";
import { defineCustomElements } from "@liquid/loader";
import { LdNotification } from "@liquid/react";
import { ReactQueryProvider } from "@src/providers";
import { RouterProvider } from "react-router-dom";
import { router } from "@src/router";
import { GlobalStyles } from "@src/styles/GlobalStyles";
import { BASE_PATH } from "@src/config";
import { Provider } from "react-redux";
import store from "./features/store/store";

declare const window: any;
defineCustomElements();

if (typeof window !== "undefined") {
  window.__LD_ASSET_PATH__ = `${window.location.origin}${BASE_PATH}/liquid/`;
}




const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <div className="ld-theme">
      <GlobalStyles />
      <Provider store={store}>
        <ReactQueryProvider>
          <LdNotification placement="top" />
          <RouterProvider router={router} fallbackElement />
        </ReactQueryProvider>
      </Provider>
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
